import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-glaccount-range',
  templateUrl: './glaccount-range.component.html',
  styleUrls: [],
  standalone: false
})
export class GlAccountRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;
  @Input() includeDACandCCAC: boolean = false;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  @Input() includeAplac: boolean = false;

  constructor() {}
}
